export const selectRates = store => store.ratesStore.data;
